<template>
  <div>
    <!-- <div v-if="$route.query.token && $route.query.id && $route.query.is_render"> -->
      <router-view />
    <!-- </div>
    <div v-else>Not Working</div> -->
  </div>
</template>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
